import React, { useEffect } from 'react';

import Init from '../../../../Init/Init';
import './Header.scss';

import PrimaryButton from '../../../Utilities/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../../Utilities/SecondaryButton/SecondaryButton';
import PhotoCarousel from '../../ProductPage/PhotoCarousel/PhotoCarousel';

// import useAnalyticsEventTracker from '../../../../GoogleAnalytics/useAnalyticsEventTracker';

// const GaTracker = ({
//     action,
//     label
// }) => {
//     const gaEventCategory = 'Header';

//     const gaEventTracker = useAnalyticsEventTracker(gaEventCategory);

//     gaEventTracker(action, label);
// };

const Header = (props) => {
    const {
        firstImage,
        secondImage,
        thirdImage,
        fourthImage,
        fifthImage,
        sixthImage,
        seventhImage
    } = Init.config.header;

    // Call API
    useEffect(() => {
        
    }, []);

    const order = (elementId) => {
        window.scrollTo({
            top: document.getElementById(elementId).offsetTop,
            behavior: 'smooth'
        });
    }

    return (
        <div id="header" className="header">
            {/* 
                1. Caps
                2. Image
            */}
            <div className="header-caption">
                <h1 className='header-caption-title'>
                    Bikin Kemasanmu #JadiLebihKeren Di <br /> Yoboy Cup!
                </h1>
                <p className="header-caption-text">
                    PT. Yoboy Oswald Imaji (YOBOY CUP) merupakan perusahaan custom kemasan cup dan box makanan. Kami menyediakan cup polosan dan custom cup plastik, paper cup, paper bowl, dan lain-lain.
                </p>
                <p className="header-caption-text">
                    Kami melayani konsumen dengan cepat, nyaman, dan tentunya menggunakan 100% kualitas terbaik. YOBOY CUP juga tersedia di Tokopedia, Tiktok, Shopee & Toco untuk pembelian cup & paper box polosan ya. Happy Shopping!
                </p>
                {/* <p className="header-caption-text">
                    <strong> *PEMBAYARAN BISA MENGGUNAKAN CREDIT CARD YA :) </strong>
                </p> */}
                <div className="header-caption-button-container">
                    <PrimaryButton 
                        onClick={ () => order("packaging-catalog") }
                        size={'sm'}
                        customClass={"header-caption-button"}
                    >
                        Custom Sekarang
                    </PrimaryButton>
                    <SecondaryButton 
                        onClick={ () => order("ready-stock") }
                        size={'sm'}
                        customClass={"header-caption-button"}
                    >
                        Lihat Produk Cup Polosan
                    </SecondaryButton>
                </div>
                <div className="header-caption-desc">
                    {/* Brands */}
                </div>
            </div>
            <PhotoCarousel photos={[
                firstImage,
                secondImage,
                thirdImage,
                fourthImage,
                fifthImage,
                sixthImage,
                seventhImage
            ]} />
            {/* <div className="header-image">
                <img src={ headerImage } />
            </div> */}
        </div>
    );
}



export default Header;